import { render, staticRenderFns } from "./addSetting.vue?vue&type=template&id=65d9be13&scoped=true"
import script from "./addSetting.vue?vue&type=script&lang=js"
export * from "./addSetting.vue?vue&type=script&lang=js"
import style0 from "./addSetting.vue?vue&type=style&index=0&id=65d9be13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9be13",
  null
  
)

export default component.exports